import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

export class categorias{
  name?:String;
  description?: String;
  questionaryId?: String;
  parentCategoryId?: String;
  weighting?: Number;
}

@Injectable({
  providedIn: 'root'
})
export class EstructuraService {
  private apiURL = environment.api_cuestionarios_rest;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  
  constructor(
    private cookieService: CookieService,
    private http: HttpClient
  ) {}

  public postCategoria(categoria){
    const cate: categorias = {
      name: categoria.name,
      questionaryId: categoria.questionaryId,
      description: categoria.description,
      parentCategoryId: categoria.parentCategoryId,
      weighting: 0
    }
    const body = JSON.stringify(cate);
    const apiURL = this.apiURL+"categories";
    return this.http.post(`${apiURL}`,body, {headers: this.headers});
  }
  public deleteCategoria(id: string) {
    const apiURL = this.apiURL+"categories/"+id;
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }
  public updateCategoria(categoria){
    const ques: categorias = {
      name: categoria.name,
      description: categoria.description
    }
    const body = JSON.stringify(ques);
    const apiURL = this.apiURL+"categories/"+categoria.id;
    return this.http.patch(`${apiURL}`,body, {headers: this.headers});
  }
  public updateCategoriaPonderacion(categoria){
    const ques: categorias = {
      weighting: categoria.weighting
    }
    const body = JSON.stringify(ques);
    const apiURL = this.apiURL+"categories/"+categoria.id;
    return this.http.patch(`${apiURL}`,body, {headers: this.headers});
  }
}
